import { render, staticRenderFns } from "./NewTournaments.vue?vue&type=template&id=3d313237&scoped=true&"
import script from "./NewTournaments.vue?vue&type=script&lang=js&"
export * from "./NewTournaments.vue?vue&type=script&lang=js&"
import style0 from "./NewTournaments.vue?vue&type=style&index=0&id=3d313237&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3d313237",
  null
  
)

export default component.exports